(function () {
  var MODEL_PREFIXES = ['iphone-', 'galaxy-', 'redmi-', 'xiaomi-', 'huawei-', 'oppo-', 'realme-', 'poco-', 'ipad-'];
  var modelsPromise = null;

  var COLLECTION_BY_COL = {
    'col-capas': 'capas',
    'col-peliculas': 'peliculas',
    'col-visores': 'visores',
    'col-relogios': 'smartwatch',
    'col-cabos-carregadores': 'cabos-e-carregadores',
    'col-som': 'som',
    'col-suportes': 'suportes',
    'col-acessorios': 'outros-acessorios',
    'col-outros': 'outros-acessorios',
  };

  var CATEGORIES = [
    {
      col: 'col-capas',
      finder: 'capas',
      label: 'Capas',
      patterns: ['capas de telemovel', 'capas telemovel', 'capas', 'capa', 'case', 'funda', 'capinha'],
    },
    {
      col: 'col-peliculas',
      finder: 'peliculas',
      label: 'Películas',
      patterns: [
        'peliculas de ecra',
        'películas de ecrã',
        'peliculas ecra',
        'películas',
        'peliculas',
        'película',
        'pelicula',
        'protetor de vidro',
        'protetor de ecrã',
        'protetor',
        'vidro temperado',
        'ecrã',
        'ecra',
      ],
    },
    {
      col: 'col-visores',
      finder: 'visores',
      label: 'Visores',
      patterns: ['visores de ecra', 'visores ecrã', 'visores lcd', 'visor lcd', 'display lcd', 'ecra lcd', 'visores', 'visor'],
    },
    {
      col: 'col-relogios',
      finder: 'smartwatch',
      label: 'Smartwatch',
      patterns: ['smartwatch', 'smart watch', 'pulseiras relogio', 'pulseiras', 'pulseira', 'relogio', 'relógio'],
    },
    {
      col: 'col-cabos-carregadores',
      finder: 'cabos',
      label: 'Cabos',
      patterns: ['cabos e carregadores', 'carregadores', 'carregador', 'powerbank', 'power bank', 'cabos', 'cabo'],
    },
    {
      col: 'col-som',
      finder: 'som',
      label: 'Som',
      patterns: ['auriculares', 'auscultadores', 'colunas', 'som'],
    },
    {
      col: 'col-suportes',
      finder: 'suportes',
      label: 'Suportes',
      patterns: ['suportes para carro', 'suportes', 'suporte', 'tripé', 'tripe'],
    },
  ];

  function normalize(text) {
    return String(text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function compact(text) {
    return normalize(text).replace(/\s/g, '');
  }

  function escapeRegExp(text) {
    return String(text).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function cleanupRemainder(text) {
    return normalize(text)
      .replace(/\b(de|para|do|da|dos|das|o|a|os|as|em|com)\b/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function patternRegex(pattern) {
    return new RegExp('(?:^|\\s)' + escapeRegExp(normalize(pattern)) + '(?:\\s|$)');
  }

  function detectCategory(query) {
    var n = normalize(query);
    if (!n) return null;

    var matches = [];
    CATEGORIES.forEach(function (cat) {
      cat.patterns.forEach(function (pattern) {
        if (patternRegex(pattern).test(n)) {
          matches.push({ cat: cat, pattern: normalize(pattern), len: normalize(pattern).length });
        }
      });
    });

    if (!matches.length) return null;
    matches.sort(function (a, b) {
      return b.len - a.len;
    });

    var best = matches[0];
    var remainder = cleanupRemainder(
      n.replace(patternRegex(best.pattern), ' ')
    );

    return {
      col: best.cat.col,
      finder: best.cat.finder,
      label: best.cat.label,
      remainder: remainder,
    };
  }

  function loadModels() {
    if (modelsPromise) return modelsPromise;
    modelsPromise = fetch(window.__TEK_SEARCH_MODELS_URL || '/assets/tek-search-models.json')
      .then(function (r) {
        if (!r.ok) throw new Error('models');
        return r.json();
      })
      .catch(function () {
        return { aliases: {}, alias_keys: [], tags: [] };
      });
    return modelsPromise;
  }

  function resolveTag(query, data) {
    var n = normalize(query);
    if (!n || !data) return null;
    var aliases = data.aliases || {};
    if (aliases[n]) return aliases[n];
    var c = compact(query);
    if (aliases[c]) return aliases[c];

    var keys = data.alias_keys || Object.keys(aliases).sort(function (a, b) {
      return b.length - a.length;
    });
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (n === key || c === compact(key)) return aliases[key];
      if (patternRegex(key).test(n)) return aliases[key];
    }
    return parseIphoneFallback(n);
  }

  function parseIphoneFallback(n) {
    var m = n.match(/^iphone\s*(\d{1,2})\s*(pro\s*max|pro max|pro|plus|mini|max)?$/i);
    if (!m) return null;
    var num = m[1];
    var variant = (m[2] || '').toLowerCase().replace(/\s+/g, ' ');
    var suffix = '';
    if (variant === 'pro max' || variant === 'max') suffix = '-pro-max';
    else if (variant === 'pro') suffix = '-pro';
    else if (variant === 'plus') suffix = '-plus';
    else if (variant === 'mini') suffix = '-mini';
    else if (variant) return null;
    return 'iphone-' + num + suffix;
  }

  function isModelTag(tag) {
    if (!tag) return false;
    return MODEL_PREFIXES.some(function (p) {
      return tag.indexOf(p) === 0;
    });
  }

  function parseAllTagQueries(q) {
    var tags = [];
    String(q || '').replace(/(?:^|\s)tag:([^\s]+)/gi, function (_, tag) {
      tags.push(String(tag).toLowerCase());
    });
    return tags;
  }

  function parseTagQuery(q) {
    var tags = parseAllTagQueries(q);
    return tags.length ? tags[0] : null;
  }

  function tagsFromAttribute(raw) {
    return String(raw || '')
      .toLowerCase()
      .split('|')
      .map(function (t) {
        return t.trim();
      })
      .filter(Boolean);
  }

  function productMatchesExactModel(productTags, targetTag) {
    if (!targetTag) return true;
    var tags = tagsFromAttribute(productTags);
    if (tags.indexOf(targetTag) !== -1) return true;
    for (var i = 0; i < tags.length; i++) {
      var tag = tags[i];
      if (tag.indexOf(targetTag + '-') === 0) return false;
      if (targetTag.indexOf('iphone-') === 0 && tag.indexOf(targetTag) === 0 && tag !== targetTag) {
        return false;
      }
    }
    return false;
  }

  function productMatchesFilters(productTags, modelTag, colTag) {
    var tags = tagsFromAttribute(productTags);
    if (colTag && tags.indexOf(colTag) === -1) return false;
    if (modelTag) return productMatchesExactModel(productTags, modelTag);
    return true;
  }

  function buildCollectionUrl(colTag, filterTags, meta) {
    var tags = [colTag].concat(filterTags || []).filter(Boolean);
    if (window.TekFinder) {
      var url = window.TekFinder.buildSearchUrl(tags, meta || {});
      if (url) return url;
    }

    var handle = COLLECTION_BY_COL[colTag];
    if (!handle) return '';
    if (!filterTags || !filterTags.length) {
      return '/collections/' + encodeURIComponent(handle);
    }

    var path =
      '/collections/' +
      encodeURIComponent(handle) +
      '/' +
      filterTags
        .map(function (tag) {
          return encodeURIComponent(tag);
        })
        .join('+');
    var params = new URLSearchParams();
    if (meta && meta.label) params.set('tek_label', meta.label);
    if (meta && meta.finder) params.set('tek_finder', meta.finder);
    var qs = params.toString();
    return path + (qs ? '?' + qs : '');
  }

  function buildTagSearchUrl(tags, meta) {
    if (window.TekFinder) {
      var url = window.TekFinder.buildSearchUrl(tags, meta || {});
      if (url) return url;
    }
    var params = new URLSearchParams();
    params.set('type', 'product');
    params.set(
      'q',
      tags
        .map(function (tag) {
          return 'tag:' + tag;
        })
        .join(' ')
    );
    if (meta && meta.label) params.set('tek_label', meta.label);
    if (meta && meta.finder) params.set('tek_finder', meta.finder);
    return '/search?' + params.toString();
  }

  function resolveQuery(query, data) {
    var existingTags = parseAllTagQueries(query);
    if (existingTags.length) {
      var colTag = null;
      var modelTags = [];
      existingTags.forEach(function (tag) {
        if (tag.indexOf('col-') === 0) colTag = tag;
        else if (isModelTag(tag)) modelTags.push(tag);
      });
      return {
        colTag: colTag,
        modelTags: modelTags,
        label: '',
        finder: colTag ? (metaFinderForCol(colTag) || '') : '',
      };
    }

    var category = detectCategory(query);
    var modelQuery = category ? category.remainder : normalize(query);
    var modelTag = modelQuery ? resolveTag(modelQuery, data) : null;

    var labelParts = [];
    if (category) labelParts.push(category.label);
    if (modelTag) {
      labelParts.push(modelTag.replace(/-/g, ' ').replace(/\biphone\b/, 'iPhone'));
    }

    return {
      colTag: category ? category.col : null,
      modelTags: modelTag ? [modelTag] : [],
      label: labelParts.join(' · '),
      finder: category ? category.finder : '',
    };
  }

  function metaFinderForCol(colTag) {
    var entry = CATEGORIES.find(function (cat) {
      return cat.col === colTag;
    });
    return entry ? entry.finder : '';
  }

  function navigateForQuery(query, data) {
    var resolved = resolveQuery(query, data);
    var colTag = resolved.colTag;
    var modelTags = resolved.modelTags || [];
    var meta = {
      label: resolved.label,
      finder: resolved.finder,
    };

    if (colTag && modelTags.length) {
      var filters = modelTags.slice();
      if (colTag === 'col-peliculas' && filters.indexOf('peliculas-ecra') === -1 && filters.indexOf('peliculas-lente-camera') === -1) {
        filters.unshift('peliculas-ecra');
      }
      return buildCollectionUrl(colTag, filters, meta);
    }
    if (colTag) {
      return buildCollectionUrl(colTag, [], meta);
    }
    if (modelTags.length) {
      return buildTagSearchUrl(modelTags, meta);
    }
    return '';
  }

  function allModelTagsFromPath() {
    var parts = window.location.pathname.replace(/\/+$/, '').split('/');
    var idx = parts.indexOf('collections');
    if (idx === -1 || parts.length <= idx + 2) return [];
    var segment = decodeURIComponent(parts[idx + 2] || '').toLowerCase();
    if (!segment) return [];
    return segment.split('+').filter(isModelTag);
  }

  function colTagFromPath() {
    var parts = window.location.pathname.replace(/\/+$/, '').split('/');
    var idx = parts.indexOf('collections');
    if (idx === -1 || parts.length <= idx + 1) return null;
    var handle = decodeURIComponent(parts[idx + 1] || '').toLowerCase();
    var map = COLLECTION_BY_COL;
    for (var col in map) {
      if (map[col] === handle) return col;
    }
    return null;
  }

  function bindSearchForms() {
    document.querySelectorAll('form[action*="/search"]').forEach(function (form) {
      if (form.dataset.tekSearchBound) return;
      form.dataset.tekSearchBound = '1';
      form.addEventListener('submit', function (e) {
        var input = form.querySelector('input[name="q"]');
        if (!input) return;
        var q = input.value.trim();
        if (!q) return;

        e.preventDefault();
        loadModels().then(function (data) {
          var url = navigateForQuery(q, data);
          if (url) {
            window.location.href = url;
            return;
          }
          var params = new URLSearchParams(new FormData(form));
          params.delete('options[prefix]');
          window.location.href = form.action.split('?')[0] + '?' + params.toString();
        });
      });
    });
  }

  function refineProductLists(modelTag, colTag) {
    if (!modelTag && !colTag) return;
    var items = document.querySelectorAll('[data-tek-filter-item]');
    if (!items.length) return;
    var visible = 0;
    items.forEach(function (item) {
      var ok = productMatchesFilters(item.getAttribute('data-tags'), modelTag, colTag);
      item.style.display = ok ? '' : 'none';
      if (ok) visible += 1;
    });
    var countEl = document.querySelector('[data-tek-live-count]');
    if (countEl) countEl.textContent = visible + ' produto(s) visíveis nesta página.';
    var countDesktop = document.getElementById('ProductCountDesktop');
    if (countDesktop && visible !== items.length) {
      countDesktop.textContent = visible + ' produto(s) nesta página (filtrados por categoria/modelo).';
    }
    document.querySelectorAll('[data-tek-search-count] strong').forEach(function (el) {
      if (visible !== items.length) {
        el.textContent = (el.textContent || '').replace(/\d+ resultado/, visible + ' resultado');
      }
    });
  }

  function initRefine() {
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      params = null;
    }

    var pathModels = allModelTagsFromPath();
    var pathCol = colTagFromPath();
    var q = params ? params.get('q') : '';
    var allTags = parseAllTagQueries(q);
    var colTag = pathCol || allTags.find(function (tag) {
      return tag.indexOf('col-') === 0;
    }) || null;
    var modelTag =
      pathModels[0] ||
      allTags.find(function (tag) {
        return isModelTag(tag);
      }) ||
      null;

    if (!modelTag && !colTag && q) {
      loadModels().then(function (data) {
        var resolved = resolveQuery(q, data);
        refineProductLists(resolved.modelTags[0] || null, resolved.colTag || null);
      });
      return;
    }

    refineProductLists(modelTag, colTag);
  }

  window.TekSearch = {
    normalize: normalize,
    detectCategory: detectCategory,
    resolveTag: resolveTag,
    resolveQuery: resolveQuery,
    loadModels: loadModels,
    productMatchesExactModel: productMatchesExactModel,
    productMatchesFilters: productMatchesFilters,
    buildCollectionUrl: buildCollectionUrl,
    modelsUrl: null,
  };

  function boot() {
    bindSearchForms();
    initRefine();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
